// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPage_container__ssois"};